import {
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Grid,
  Switch,
} from "@mui/material";
import { useState } from "react";
import { Form, useSubmit } from "react-router-dom";
import Section from "./components/Section";

const PublisherStatusSection = ({
  publisher = {}
}) => {
  const [isChecked, setIsChecked] = useState(publisher.active ?? false);
  const submit = useSubmit();

  return (
    <Section title={publisher.name}>
        <Grid item xs={6}>
          <FormControl component="fieldset">
            <FormLabel component="legend">Publisher ID</FormLabel>
            <FormGroup aria-label="position" row>
              {publisher.id}
            </FormGroup>
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          <Form
            method="post"
            onChange={(e) => submit(e.currentTarget)}
          >
            <FormControl component="fieldset">
              <FormLabel component="legend">3p Programmatic Demand Enabled</FormLabel>
              <FormGroup row>
                <input type="hidden" name="active" value="false" />
                <FormControlLabel
                  control={
                    <Switch
                      name="active"
                      checked={isChecked}
                      onChange={(event) => { setIsChecked(event.target.checked) }}
                      value={"true"}
                    />
                  }
                  label={isChecked ? "On" : "Off"}
                />
              </FormGroup>
            </FormControl>
          </Form>
      </Grid>
    </Section>
  )
}

export default PublisherStatusSection;
